// extracted by mini-css-extract-plugin
export default {"flipIn":"shell_flipIn__SQlLh","shell-flip-in":"shell_shell-flip-in__icqPQ"};